import { render } from "./ShowVoucherGiftHistory.vue?vue&type=template&id=0cf4ac0d&scoped=true"
import script from "./ShowVoucherGiftHistory.vue?vue&type=script&lang=js"
export * from "./ShowVoucherGiftHistory.vue?vue&type=script&lang=js"

import "./ShowVoucherGiftHistory.vue?vue&type=style&index=0&id=0cf4ac0d&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf4ac0d"]])

export default __exports__